import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";

import {
  CREATE_LINEITEM_FAILURE,
  CREATE_LINEITEM_REQUEST,
  CREATE_LINEITEM_SUCCESS
} from "../types";

export default fundingRequest => lineItem => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(CREATE_LINEITEM_REQUEST)());
    const item = await api.factoring.createLineItem(fundingRequest, lineItem);
    const data = normalize(item, schema.lineItem);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(CREATE_LINEITEM_SUCCESS)({
        fundingRequest,
        lineItem: data.result
      })
    );
    return item;
  } catch (err) {
    dispatch(createAction(CREATE_LINEITEM_FAILURE)(err));
    throw err;
  }
};
